module.exports = __webpack_public_path__ + "static/media/OpenSansCondensed-Bold.cfd3dce5.ttf";